import Oe from "./base-device-parser.js";
import { Browsers as bi, OperatingSystems as so } from "./device-constants.js";
export default class Si extends Oe {
  constructor() {
    super(), (this.Vd = Si.hf(navigator.userAgent || ""));
  }
  ff() {
    return this.Vd[0] || "Unknown Browser";
  }
  cf() {
    return this.Vd[1] || "Unknown Version";
  }
  rc(r) {
    for (let n = 0; n < r.length; n++) {
      const e = r[n].string;
      let i = Si.lf(e, r[n]);
      if (i)
        return (
          i === so.Pg && navigator.maxTouchPoints > 1 && (i = so.co),
          Promise.resolve(i)
        );
    }
    return Promise.resolve(navigator.platform);
  }
  static hf(r) {
    let n,
      e =
        r.match(
          /(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chatgptbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i,
        ) || [];
    if (-1 !== r.indexOf("(Web0S; Linux/SmartTV)"))
      return ["LG Smart TV", null];
    if (-1 !== r.indexOf("CrKey")) return ["Chromecast", null];
    if (
      -1 !== r.indexOf("BRAVIA") ||
      -1 !== r.indexOf("SonyCEBrowser") ||
      -1 !== r.indexOf("SonyDTV")
    )
      return ["Sony Smart TV", null];
    if (-1 !== r.indexOf("PhilipsTV")) return ["Philips Smart TV", null];
    if (r.match(/\b(Roku)\b/)) return ["Roku", null];
    if (r.match(/\bAFTM\b/)) return ["Amazon Fire Stick", null];
    if (e[1] === bi.rO) {
      if (r.includes(bi.Sg)) return [bi.Sg, e[2]];
      if (
        ((n = r.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/)),
        null != n)
      )
        return (
          (n = n.slice(1)),
          (n[0] = n[0].replace("OPR", bi.oO)),
          (n[0] = n[0].replace("EdgA", bi.eO)),
          "Edg" === n[0] && (n[0] = bi.eO),
          [n[0], n[1]]
        );
    }
    if (
      e[1] === bi.Bg &&
      ((n = r.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/)), null != n)
    )
      return (
        (n = n.slice(1)), (n[0] = n[0].replace("EdgiOS", bi.eO)), [n[0], n[1]]
      );
    if (
      ((e = e[2] ? [e[1], e[2]] : [null, null]),
      e[0] === bi.Bg &&
        null != (n = r.match(/version\/(\.?\d+(\.\d+)*)/i)) &&
        e.splice(1, 1, n[1]),
      null != (n = r.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/)) &&
        e.splice(1, 1, n[2]),
      e[0] === bi.oO && null != (n = r.match(/mini\/(\.?\d+(\.\d+)*)/i)))
    )
      return ["Opera Mini", n[1] || ""];
    if (e[0]) {
      const r = e[0].toLowerCase();
      "crios" === r && (e[0] = bi.rO),
        "tizen" === r && ((e[0] = "Samsung Smart TV"), (e[1] = null)),
        "samsungbrowser" === r && (e[0] = "Samsung Browser");
    }
    return e;
  }
}
